<template>
  <IndicatorWrapper class="digital-evol-rank" :status="status" v-if="visible">
    <div class="top">
      <TextWithFilters ref="textComponent" textKey="digital_ranking_text_with_filters" :textData="dynamicTextData" v-model="currentFilters"></TextWithFilters>
    </div>
    <div class="bottom">
      <DigitalRankStairs :data="indicatorData.main_value" 
      :status="status" 
      :sector="currentFilters.custom_sects_digital_rank" 
      :compareData="indicatorData.compare_data"
      :timeSelection="currentFilters.timeScaleMonth"
      @changeTime="changeTime"
      ></DigitalRankStairs>
      <ChartLegend :items="legendItems" v-show="isCompareMode"></ChartLegend>
      <ChartDescription :values="currentFilters" :indicator="indicator" descriptionKey="digital_ranking_info"></ChartDescription>
    </div>
  </IndicatorWrapper>
</template>

<script>
import Api from '@/api'
import indDynamicText from '@/mixins/indDynamicText'
import indData from '@/mixins/indData'
import TextWithFilters from '@/components/IndicatorCards/parts/TextWithFilters'
import DigitalRankStairs from '@/components/IndicatorCards/parts/charts/DigitalRankStairs'
import ChartDescription from '@/components/IndicatorCards/parts/ChartDescription'
import ChartLegend from '@/components/IndicatorCards/parts/ChartLegend'
import IndicatorWrapper from '@/components/IndicatorCards/parts/IndicatorWrapper'
import data from '@/assets/fake_data/generics/ind_var_sector_online.json'
import data2 from '@/assets/fake_data/generics/ind_var_sector_online2.json'
import {capitalize} from '@/utils/textUtils'
import moment from 'moment';

export default {
  name: 'DigitalEvol',

  mixins: [indData, indDynamicText],

  components: {
    TextWithFilters,
    ChartDescription,
    DigitalRankStairs,
    IndicatorWrapper,
    ChartLegend
  },
  computed: {
    // evolutiveStatus () {
    //   // return (!this.indicatorData['evolutive'] || this.$asyncComputed['asc_evolutive'].updating) ? {status:'fetching'} : {status:'ready'}
    //   if(this.$asyncComputed['asc_evolutive'].updating) return {status:'fetching'}
    //   else if(!this.indicatorData['evolutive']) return {status:'no-data'}
    //   else return {status:'ready'}
    // },
    indicatorData() {
      return {
        main_value: {
          required: true,
          get () {
            let filters = {...this.currentFilters}
            filters.timeScale = 'MONTH' // need for endpoint, only possible value is MONTH for now
            return Api.getIndicatorData('ind_var_sector_online', filters)
            //return new Promise((res)=>res(data))
          }
        },
        compare_data: {
          required: false,
          triggers_jump: false,
          get () {
            let filters = {...this.currentFilters}
            filters.timeScale = 'MONTH'
            return this.isCompareMode ? Api.getIndicatorData('ind_var_sector_online',filters, {
               node: this.compareNodeInfo,
               avoidCancel: true
            }) :
            Promise.resolve(false)
            /*return this.isCompareMode ? new Promise(res=>{
              res(data2)
            }) : 
            Promise.resolve(false)*/
          }
        }
      }
    },
    dynamicTextData () {
      let currentMonthId = this.currentFilters.timeScaleMonth || 'var_sector_online_month'
      let currentMonth = this.indicatorData.main_value && this.indicatorData.main_value.data.find((d)=>d.id===currentMonthId)
      let sortedMonthdata = currentMonth && currentMonth.data.slice()
      sortedMonthdata && sortedMonthdata.sort((a,b)=>b.value-a.value)
      let customSectors = sortedMonthdata && sortedMonthdata.map((o)=>({value:o.id,label:this.t(o.id)}))
      
      let sectorData = currentMonth && (sortedMonthdata.find((d)=>d.id===this.currentFilters.custom_sects_digital_rank) || sortedMonthdata[0])
      return [
        {
          type: 'select',
          id: 'custom_sects_digital_rank',
          options: customSectors  //|| [this.currentFilters.custom_sects_digital_rank]
        },
        {
          type: 'select',
          id: 'timeScaleMonth',
        },
        {
          type: 'value',
          id: 'VALUE_1',
          value: sectorData?sectorData.value:'--',
          unit: '%'
        }
      ]
    },
  },
  methods:{
    changeTime(e){
      this.currentFilters = {...this.currentFilters, timeScaleMonth: e.value}
    }
  }
}
</script>

<style lang="stylus" scoped>
.digital-evol-rank
  .bottom
    .desktop &
      margin-top: vh(-50px)
</style>